import Card from './Base';

export default Card;
